import RefundHistoryContainer from "./RefundHistoryContainer"

const RefundList = () => {
  return (
      <div className='page-body'>
          <RefundHistoryContainer />
      </div>
  )
}

export default RefundList